// modules/serviceWorker.js
const state = {
  showInstallIcon: false,
  deferredPrompt: null,
};

const mutations = {
  setShowInstallIcon(state, value) {
    state.showInstallIcon = value;
  },
  setDeferredPrompt(state, event) {
    state.deferredPrompt = event;
  },
};

const actions = {
  triggerShowInstallIcon({ commit }, value) {
    commit("setShowInstallIcon", value);
  },
  setDeferredPrompt({ commit }, event) {
    commit("setDeferredPrompt", event);
  },
};

const getters = {
  showInstallIcon: (state) => state.showInstallIcon,
  deferredPrompt: (state) => state.deferredPrompt,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
